/**
 * Canonical CimmpleFlow pricing (US + India).
 * Import from here instead of hardcoding amounts in page components.
 *
 * India INR list prices are FX-rounded equivalents of US seats
 * at ~₹96/USD (July 2026), rounded to clean ₹100 steps:
 *   $59 → ₹5,500 | $69 → ₹6,500 | $15 → ₹1,500
 */
export const cimmpleFlowUsPricing = {
  annualPerUserMonth: 59,
  monthlyPerUserMonth: 69,
  currencySymbol: '$',
  annualDisplay: '$59',
  monthlyDisplay: '$69',
  annualPeriod: '/user/month',
  annualDescription: 'Billed annually. $69/user if billed monthly.',
  monthlyDescription: 'Billed monthly. Save with annual billing at $59/user/month.',
  priceLabel: 'From $59/user/month',
  everythingIncludedHeadline: 'Everything Included. Simple Per-User Pricing.',
  shopFloorUser: {
    name: 'Shop Floor User',
    annualPerUserMonth: 15,
    display: '$15',
    period: '/user/month',
    description: 'Limited shop-floor access for operators—clock in, view jobs, update status, and quality checks.',
    features: [
      'Clock in / clock out',
      'View assigned jobs',
      'Update job status',
      'Quality checks',
    ],
  },
  includedHighlights: [
    'All modules included',
    'Unlimited jobs',
    'Unlimited customers',
    'Unlimited inventory',
    'Unlimited BOMs',
    'Unlimited work orders',
    'No hidden module fees',
    'Cloud hosting included',
    'Regular updates included',
    'AI Invoice Extraction',
    'Document Management',
    'VendorConnect™',
    'APIs included',
  ],
  includedModules: [
    'Quoting',
    'Purchasing',
    'Inventory',
    'Job Management',
    'Scheduling',
    'Quality',
    'Accounting',
    'Reports',
    'AI Invoice Extraction',
    'Document Management',
    'VendorConnect™',
    'APIs',
    'Updates',
  ],
} as const;

export const cimmpleFlowIndiaPricing = {
  /** ~$59 × ₹96, rounded */
  annualPerUserMonth: 5500,
  /** ~$69 × ₹96, rounded */
  monthlyPerUserMonth: 6500,
  currencySymbol: '₹',
  annualDisplay: '₹5,500',
  monthlyDisplay: '₹6,500',
  annualPeriod: '/user/month',
  annualDescription: 'Billed annually. ₹6,500/user if billed monthly.',
  monthlyDescription: 'Billed monthly. Save with annual billing at ₹5,500/user/month.',
  priceLabel: 'From ₹5,500/user/month',
  everythingIncludedHeadline: 'Everything Included. Simple Per-User Pricing.',
  description:
    'A modern cloud operating system for machine shops—everything included, priced per user.',
  shopFloorUser: {
    name: 'Shop Floor User',
    /** ~$15 × ₹96, rounded */
    annualPerUserMonth: 1500,
    display: '₹1,500',
    period: '/user/month',
    description: 'Limited shop-floor access for operators—clock in, view jobs, update status, and quality checks.',
    features: [
      'Clock in / clock out',
      'View assigned jobs',
      'Update job status',
      'Quality checks',
    ],
  },
  includedHighlights: cimmpleFlowUsPricing.includedHighlights,
  includedModules: cimmpleFlowUsPricing.includedModules,
} as const;
